export default class Versions {
    constructor(client) {
        this.url = '/versions';
        this.client = client;
    }
    Get() {
        return this.client.get(this.url);
    }
}
